import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import HttpErrorResponse from '../interfaces/common/httpErrorResponse';
import Paging from '../interfaces/common/paging';
import Pagination from '../interfaces/common/pagination';
import { RootState } from '../setup';
import CorrectedStatus from '../interfaces/output/correctedStatus';

export type CorrectedStatusState = {
    correctedStatus: CorrectedStatus;
    isLoading: boolean;
    correctedStatuses: Pagination<CorrectedStatus>;
    error: HttpErrorResponse | undefined;
};

const initialState: CorrectedStatusState = {
    correctedStatus: {} as CorrectedStatus,
    correctedStatuses: { content: [] as Array<CorrectedStatus> } as Pagination<CorrectedStatus>,
    isLoading: false,
    error: undefined
};

export const correctedStatusSlice = createSlice({
    name: 'correctedStatus',

    initialState,
    reducers: {
        fetchCorrectedStatuses: (state: CorrectedStatusState, _action: PayloadAction<{paging: Paging}>) => {
            state.isLoading = true;
        },
        fetchCorrectedStatusesSuccess: (state: CorrectedStatusState, action: PayloadAction<Pagination<CorrectedStatus>>) => {
            state.isLoading = false;
            state.correctedStatuses = action.payload;
        },
        fetchCorrectedStatusesError: (state: CorrectedStatusState, action: PayloadAction<HttpErrorResponse>) => {
            state.isLoading = false;
            state.error = action.payload;
        },
        fetchCorrectedStatusById: (state: CorrectedStatusState, _action: PayloadAction<string>) => {
            state.isLoading = true;
        },
        fetchCorrectedStatusByIdSuccess: (state: CorrectedStatusState, action: PayloadAction<CorrectedStatus>) => {
            state.isLoading = false;
            state.correctedStatus = action.payload;
        },
        fetchCorrectedStatusByIdError: (state: CorrectedStatusState, action: PayloadAction<HttpErrorResponse>) => {
            state.isLoading = false;
            state.error = action.payload;
        }
    }
});

export const { fetchCorrectedStatusById, fetchCorrectedStatusByIdError, fetchCorrectedStatusByIdSuccess,
    fetchCorrectedStatuses, fetchCorrectedStatusesError, fetchCorrectedStatusesSuccess } = correctedStatusSlice.actions;

export const isLoadingCorrectedStatus = (state: RootState): boolean => state.correctedStatusReducer.isLoading;
export const getCorrectedStatuses = (state: RootState): Pagination<CorrectedStatus> => state.correctedStatusReducer.correctedStatuses;
export const getCorrectedStatus = (state: RootState): CorrectedStatus => state.correctedStatusReducer.correctedStatus;

export default correctedStatusSlice.reducer;